import script from "./PartnerWhitelabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./PartnerWhitelabel.vue?vue&type=script&lang=ts&setup=true"

import "./PartnerWhitelabel.vue?vue&type=style&index=0&id=4eabd5ca&scoped=true&lang=css"

import exportComponent from "/builds/nmhwyAssu/0/batesbus/app.securechannel.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eabd5ca"]])

export default __exports__